import { type FC, memo, type PropsWithChildren } from 'react';

import { ImageComponent } from '@/components/Image';
import { useGetCommonStore } from '@/store';

import { ScTopSection } from './styled';

interface TopSectionProps {
  bg: string;
  leftImg: string;
  leftDecorImg: string;
  rightImg: string;
  rightDecorImg: string;
  mobImg: string;
}

const TopSectionImages = memo(
  ({
    bg,
    mobImg,
    leftImg,
    leftDecorImg,
    rightImg,
    rightDecorImg,
  }: TopSectionProps) => {
    const useCommonStore = useGetCommonStore();

    const isMobileDevice = useCommonStore.use.isMobileDevice();
    return (
      <>
        <ImageComponent
          alt="bg"
          className="bg"
          fill
          src={isMobileDevice ? mobImg : bg}
        />
        <ImageComponent
          alt="coins"
          className="coins"
          height={652}
          src={leftDecorImg}
          width={291}
        />
        <ImageComponent
          alt="gift"
          className="gift"
          height={652}
          src={rightDecorImg}
          width={291}
        />
        <ImageComponent
          alt="deskLeft"
          className="deskLeft"
          height={577}
          src={leftImg}
          width={385}
        />
        <ImageComponent
          alt="deskRight"
          className="deskRight"
          height={384}
          src={rightImg}
          width={308}
        />
        <div className="shine left" />
        <div className="shine right" />
      </>
    );
  }
);

export const TopSection: FC<PropsWithChildren<TopSectionProps>> = ({
  bg,
  leftImg,
  leftDecorImg,
  rightImg,
  rightDecorImg,
  mobImg,
  children,
}) => (
  <ScTopSection>
    <TopSectionImages
      bg={bg}
      leftDecorImg={leftDecorImg}
      leftImg={leftImg}
      mobImg={mobImg}
      rightDecorImg={rightDecorImg}
      rightImg={rightImg}
    />

    {children}
  </ScTopSection>
);
